import Image from 'next/image';

export default function CompanyLogoFull() {
  return (
    <>
      <div style={{ position: 'relative', width: '100%', height: '55px' }}>
        <Image
          src="/logos/logoFULL.png"
          alt="Company Logo"
          layout="fill"
          objectFit="contain"
        />
      </div>
    </>
  );
}